import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { MonitoramentoListWrapper } from './monitoramento-list/MonitoramentoList'

const MonitoramentoPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.monitoramento.descricao')}>
              Monitoramento de Atendimentos
            </PageTitle>
            <MonitoramentoListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default MonitoramentoPage
